import { Suspense, lazy } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, RouteObject, useLocation } from "react-router-dom";
import { selectCurrentUser, selectIsLoggedIn } from "store/user/user.selector";
import { authLinks } from "utils/helper/links";
import { REDIRECT_URI, USER_TOKEN } from "utils/helper/states";
import Subcategory from "./sub_categories";
import { houseLoader, providerLoader } from "loaders/provider.loader";
import ErrorPage from "components/error/error.component";
import Preloader from "components/toolkit/preloader.component";
import { ImageViewerPage } from "./image_viewer_page";
// import WorkersProfile from "./worker_profile";

const Services = lazy(() => import("./services"));
const Userhome = lazy(() => import("./dashboard/home"));
const UserProfile = lazy(() => import("./dashboard/user_profile"));

const UserDashboard = lazy(() => import("./dashboard"));
const Notifications = lazy(() => import("./dashboard/notifications"));
const Chats = lazy(() => import("./dashboard/chat"));
const AccountVerification = lazy(
  () => import("./dashboard/accountverification")
);
const ServiceProviderProfile = lazy(
  () => import("./dashboard/service_provider_profile")
);
const Chathistory = lazy(() => import("./dashboard/chathistory"));
const WorkersProfile = lazy(() => import("./worker_profile"));
const ChatBoxPage = lazy(() => import("./chatbbox/chatbox"));
const EditProfile = lazy(() => import("./dashboard/settings/editprofile"));
const SettingsPage = lazy(() => import("./dashboard/settings"));
const ChangePassword = lazy(
  () => import("./dashboard/settings/changepassword")
);

function ProtectedRoutes() {
  const isLoggedIn = useSelector(selectIsLoggedIn),
    user = useSelector(selectCurrentUser);
  const location = useLocation();
  if (isLoggedIn && user != null) {
    if (user?.token) {
      localStorage.setItem(USER_TOKEN, user.token);
    }
    return !user.emailVerified && !user.phoneVerified ? (
      <Navigate to={authLinks.verify} replace />
    ) : (
      <Outlet />
    );
  }
  sessionStorage.setItem(REDIRECT_URI, location.pathname);
  return <Navigate to={authLinks.login} replace />;
}

export const protectedRoutes: RouteObject[] = [
  {
    path: "/services",
    element: <Services />,
  },
  { path: "/service-providers", element: <Subcategory isHouse={false} /> },
  { path: "/house", element: <Subcategory isHouse={true} /> },
  {
    path: "/service-provider/:id",
    element: (
      <Suspense fallback={<Preloader />}>
        <WorkersProfile isHouse={false} />
      </Suspense>
    ),
    loader: providerLoader,
    errorElement: <ErrorPage />,
  },
  {
    path: "/house/:id",
    element: (
      <Suspense fallback={<Preloader />}>
        <WorkersProfile isHouse={true} />
      </Suspense>
    ),
    loader: houseLoader,
    errorElement: <ErrorPage />,
  },
  // { path: "/report", element: <ReportPage /> },
  // { path: "/review", element: <ReviewPage /> },
  // { path: "/chatbox", element: <ChatBoxPage /> },
  { path: "/images", element: <ImageViewerPage /> },
  { path: "/chatbox", element: <ChatBoxPage /> },
  {
    element: <UserDashboard />,
    children: [
      { path: "/dashboard", element: <Userhome /> },
      { path: "/dashboard/profile", element: <UserProfile /> },
      { path: "/dashboard/notifications", element: <Notifications /> },
      {},
      {
        path: "/dashboard/messages",
        element: <Chats />,
        children: [
          {
            path: "/dashboard/messages/chat-history",
            element: <Chathistory />,
          },
        ],
      },
      {
        path: "/dashboard/account-verification",
        element: <AccountVerification />,
      },
      { path: "/dashboard/transaction", element: <ServiceProviderProfile /> },
    ],
  },
  {
    element: <UserDashboard isSetting={true} />,
    children: [
      { path: "/dashboard/settings", element: <SettingsPage /> },
      { path: "/dashboard/settings/edit-profile", element: <EditProfile /> },
      {
        path: "/dashboard/settings/change-password",
        element: <ChangePassword />,
      },
    ],
  },
];
export default ProtectedRoutes;
